import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "../../../components/Sidebar";
import BrokerToolsPanel from "./BrokerToolsPanel";
import "../../css/IbDashboard.css";
import "../../css/IbBrokerTools.css";

export default function IbBrokerTools() {
  const { t } = useTranslation("mobile");
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("userData");
      if (stored) setUser(JSON.parse(stored));
    } catch (_) {
      setUser(null);
    }
  }, []);

  const pageTitle = t("ib_broker_tools", { defaultValue: "Broker tools" });

  return (
    <div className="ib-dashboard-page ib-broker-tools-page">
      <Sidebar user={user} />
      <div className="ib-dashboard-main">
        <div className="container-fluid px-0 w-100 ib-dashboard-main-inner">
          <header className="ib-broker-tools-head">
            <h1 className="ib-broker-tools-title">{pageTitle}</h1>
            <p className="ib-broker-tools-sub">
              {t("ib_broker_tools_sub", {
                defaultValue: "Templates and resources available for your brokerage.",
              })}
            </p>
          </header>
          <BrokerToolsPanel user={user} />
        </div>
      </div>
    </div>
  );
}
